export default __webpack_public_path__ + "static/media/DangerBottomSheet.384c1975.svg";